import BrokersApi from '../BrokersApi';
import * as types from './ActionTypes';
import { Promise } from 'es6-promise';
import notify from '../../../shared/feedback/notifications';
import { Translate } from '../../../shared/LanguageService';

function getBrokerTreeSuccess(result: any) {
    return { type: types.GET_BROKERTREE_SUCCESS, result: result };
}

export function getBrokerTree(
    nodeId?: number,
    toggle?: boolean,
    search?: string,
    selectedNodeId?: number
) {
    return (dispatch: (result: any) => void) => {
        if (toggle === true) {
            dispatch(getBrokerTreeSuccess({ nodeId: nodeId, toggle: toggle }));
            return Promise.resolve();
        }

        return BrokersApi.getBrokerTree(nodeId, search, selectedNodeId).then((result: any) => {
            dispatch(
                getBrokerTreeSuccess({
                    nodeId: nodeId,
                    toggle: toggle,
                    list: result
                })
            );
        });
    };
}

function addBrokerTreeSuccess(result: any) {
    return { type: types.ADD_BROKERTREE_SUCCESS, result };
}

export function addBrokerTree(data: any) {
    return (dispatch: (result: any) => void) =>
        BrokersApi.addBrokerTreeNode(data).then((result: any) => {
            dispatch(addBrokerTreeSuccess(result));
        });
}

function moveBrokerTreeSuccess(result: any) {
    return { type: types.MOVE_BROKERTREE_SUCCESS, result };
}

export function moveBrokerTree(id: number, data: any) {
    return (dispatch: (result: any) => void) =>
        BrokersApi.moveBrokerTreeNode(id, data).then((result: any) => {
            dispatch(moveBrokerTreeSuccess(result));
            if (result && result.keptOwnCustomerAgreement) {
                notify.warning(
                    Translate('broker-tree/move/firm-keeps-own-agreement', {
                        firm: result.keptOwnCustomerAgreement.brokerFirmName,
                        agreement: result.keptOwnCustomerAgreement.customerAgreementName,
                        chainAgreement: result.keptOwnCustomerAgreement.chainCustomerAgreementName
                    })
                );
            }
        });
}

function deleteBrokerTreeSuccess(result: any) {
    return { type: types.DELETE_BROKERTREE_SUCCESS, result };
}

export function deleteBrokerTree(id: number) {
    return (dispatch: (result: any) => void) =>
        BrokersApi.deleteBrokerTreeNode(id).then(() => {
            dispatch(deleteBrokerTreeSuccess(id));
        });
}

function restoreBrokerTreeSuccess(result: any) {
    return { type: types.RESTORE_BROKERTREE_SUCCESS, result };
}

export function restoreBrokerTree(id: number) {
    return (dispatch: (result: any) => void) =>
        BrokersApi.restoreBrokerTreeNode(id).then(() => {
            dispatch(restoreBrokerTreeSuccess(id));
        });
}

export function updateBrokerTree(brokerTreeNodes: any[]) {
    return (dispatch: (brokerTreeNodes: any) => void) => {
        dispatch({ type: types.UPDATE_BROKER_TREE, result: brokerTreeNodes });
    };
}
